var YesNoStatus = {
  NO: 0,
  YES: 1
}

export { YesNoStatus }
